import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { editStateSalesLead } from "../atoms/SalesLeadAtoms";
import { SalesLeadData } from "../types/SalesLeadInterface";

export default function SalesLeadDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: SalesLeadData | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateSalesLead);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.name || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [inputId, setInputId] = useState(data?.employeeId || "");

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-2 gap-x-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="name"
                label="Sales Lead Name"
                type="text"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  setInputData(value);
                  if (
                    value.length === 0 ||
                    inputId?.toString() == "" ||
                    (value === data?.name &&
                      checkBoxChanges === data?.isActive &&
                      inputId == data?.employeeId)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                required={true}
                className={
                  formMethods.formState.errors.name &&
                  formMethods.formState.errors.name.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("name", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="employeeId"
                label="Employee ID"
                type="number"
                onChange={(e) => {
                  setInputId(e.target.value);
                  if (
                    e.target.value.length === 0 ||
                    inputData?.length === 0 ||
                    (e.target.value == data?.employeeId &&
                      checkBoxChanges === data?.isActive &&
                      inputData === data?.name)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                required={true}
                className={
                  formMethods.formState.errors.employeeId &&
                  formMethods.formState.errors.employeeId.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("employeeId", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
              />
            </div>
            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.name &&
                        inputId == data?.employeeId)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
